import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Progress } from 'semantic-ui-react'

import './LoaderProgress.css'

class LoaderProgress extends PureComponent {
  render() {
    const { children, content, positive } = this.props

    return (
      <Progress active className="LoaderProgress" color={positive ? 'green' : 'orange'} percent={100} size="tiny">
        {content || children}
      </Progress>
    )
  }
}

LoaderProgress.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  content: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  positive: PropTypes.bool,
}

export default LoaderProgress
